import { Component, ElementRef, Input, ViewChild } from "@angular/core";
import { ApplicationContextService } from "src/app/application-context.service";

@Component({
  selector: "ads-wizard",
  templateUrl: "./wizard.component.html",
  styleUrls: ["./wizard.component.scss"],
})
export class WizardComponent {
  @ViewChild("wizard") wizard: ElementRef;
  public wizardActiveStep: string = "";
  public wizardActiveIcon: string = "";
  public wizardActiveCaption: string = "";
  public wizardActiveImage: string = "";
  @Input("wizardActiveItem") wizardActiveItem: string;
  @Input("wizardClass") wizardClass: string = "";
  @Input("wizardStyle") wizardStyle: string = "";
  @Input("wizardDynClass") wizardDynClass: string = "";
  constructor(public appContext: ApplicationContextService) { }

  ngAfterViewInit() {
    this.setActiveWizardItemInResponsiveMode();
  }

  ngOnChanges() {
    this.setActiveWizardItemInResponsiveMode();
  }
  setActiveWizardItemInResponsiveMode() {
    this.wizard?.nativeElement?.childNodes[0]?.childNodes.forEach(
      (wizardchild) => {
        wizardchild?.childNodes.forEach((child) => {
          if (child.innerText == this.wizardActiveItem) {
            if (child.className == "vm-wizard__caption") {
              this.wizardActiveCaption = child.innerText;
            }
            if (
              wizardchild?.childNodes[0]?.childNodes[0]?.className ==
              "vm-wizard__step__count"
            ) {
              this.wizardActiveStep =
                wizardchild?.childNodes[0]?.childNodes[0]?.innerText;
            } else if (
              wizardchild?.childNodes[0]?.childNodes[0]?.className ==
              "material-symbols-outlined vm-icon"
            ) {
              this.wizardActiveIcon =
                wizardchild?.childNodes[0]?.childNodes[0]?.innerText;
            } else {
              this.wizardActiveImage =
                wizardchild?.childNodes[0]?.childNodes[0]?.attributes[
                  "src"
                ].value;
            }
          }
        });
      }
    );
  }
}
